import React from 'react'
import ToastProps from 'interfaces/toast-props'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Row, Col } from 'react-bootstrap'
import styles from './ToastBody.module.scss'

const ToastBody: React.FC<ToastProps> = ({ icon, text }) => {
  return (
    <Row className="align-items-center bg-content">
      {icon ? (
        <Col xs={1}>
          <FontAwesomeIcon icon={icon} />
        </Col>
      ) : (
        ''
      )}
      <Col className={styles.textContainer}>{text}</Col>
    </Row>
  )
}

export default ToastBody
